import type { FC } from 'react'
import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'

import { SelectString } from '../../../../core/components/SelectString'
import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { Project } from '../../types/Project'

export interface Props {
  project: Project
  disciplineID: string
  handleClose: () => void
}

const PRDUDUCT_ACTIEF_REDENEN = [
  'Afhandeling buiten DSP',
  'Incorrecte opdrachtverstrekking',
]

export const ProductActief: FC<Props> = ({
  project,
  disciplineID,
  handleClose,
}) => {
  const { mutate: saveEvent, isPending } = useSaveEvent()
  const [reden, setReden] = useState('Afhandeling buiten DSP')
  const [error, setError] = useState<string | null>(null)

  const updateReden = (reden: string) => {
    setReden(reden)

    if (PRDUDUCT_ACTIEF_REDENEN.includes(reden)) {
      setError(null)
    } else {
      setError('Verplicht bij deactiveren')
    }
  }

  const handleClick = () => {
    saveEvent(
      {
        id: project.aanvraagID,
        type: 'product_actief',
        source: 'manual',
        data: {
          disciplineID,
          reden,
          isActive: false,
        },
      },
      {
        onSuccess: () => handleClose(),
      },
    )
  }

  return (
    <>
      <DialogTitle>Deactiveren aansluiting</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <SelectString
            options={PRDUDUCT_ACTIEF_REDENEN}
            onChange={(reden) => {
              updateReden(reden || '')
            }}
            value={reden}
            required
            label="Reden"
            error={!!error}
            helperText={error}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Annuleren
        </Button>{' '}
        <Button
          disabled={isPending}
          onClick={() => handleClick()}
          color="primary"
        >
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
